// extracted by mini-css-extract-plugin
var _1 = "InfiniteLoadGrid_loadingItem__05155";
var _2 = "InfiniteLoadGrid_root__8863c";
export { _1 as "loadingItem", _2 as "root" }
